import React, { useContext, useMemo } from 'react'

import DataContextProvider from '../../../explorer/map/DataContext'
import MapControlContextProvider from '../../../explorer/map/MapControlContext'
import Panel from '../../../../elem/panel/Panel'
import { mapPanel as panelClassConfig } from '../../../../../utils/styles/panelStyles'
import ViewMap from './ViewMap'
import WithConfig from '../../../../wrappers/withConfig'
import ViewMapMerge from './ViewMapMerge'
import FacilityAssignmentDataContextProvider from '../facilityAssignment/DataContext'

export default ({ formType }) => {
    return (
        <DataContextProvider>
            <MapControlContextProvider mapMenu={`SubmissionsMap`}>
                <Panel panelClassConfig={panelClassConfig(12)}>
                    <ViewMap />
                </Panel>
            </MapControlContextProvider>
        </DataContextProvider>
    )
}
